module.exports = __webpack_public_path__ + "media/images/water-reduction-bg-33c72bc6bc55221e80cff477ac0a8169.png";